import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import parse from "html-react-parser";
import "./format-21.style.scss";
import { Container, Row } from "react-bootstrap";

// OPTIONAL: slick css (kalau belum)

const Format21 = (props) => {
  const [data, setData] = useState({});
  const [fotoData, setFotoData] = useState(null);

  useEffect(() => {
    if (props?.item) {
      setData(props.item);
    }
  }, [props.item]);

  useEffect(() => {
    if (props?.item?.link_video) {
      try {
        const parsed =
          typeof props.item.link_video === "string"
            ? JSON.parse(props.item.link_video)
            : props.item.link_video;
        console.log("parsed",parsed);
        setFotoData(parsed);
      } catch (err) {
        console.error("Invalid JSON link_video", err);
        setFotoData(null);
      }
    }
  }, [props.item?.link_video]);

  const checkValue = (val) => val && val !== "";

  const toValidUrl = (url) =>
    /^https?:\/\//i.test(url) ? url : `https://${url}`;

  const renderBanner = (desktop, mobile) => {
    if (typeof window === "undefined") return desktop;
    return window.innerWidth < 768 && mobile ? mobile : desktop;
  };

  const FotoSlide = ({ dataBanner = [] }) => {
    const slidesCount = dataBanner.length;
    const settings = {
      dots: slidesCount > 1,
      infinite: slidesCount > 4,
      speed: 600,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: slidesCount > 1,
      autoplaySpeed: 4000,
      arrows: slidesCount > 1,
      adaptiveHeight: false,
    };

    if (!dataBanner.length) return null;

    return (
      <div className="box-banner-slideshow">
        <Slider {...settings} className="slider-slideshow">
          {dataBanner.map((item, i) => (
            <div key={i}>
              <div className="content-slide">
                <div className="thumb-box">
                  <img
                    src={renderBanner(item?.foto, "/assets/images/video-default.jpg")}
                    alt={item?.name || "banner"}
                  />
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    );
  };

  
  return (
    <Container bsPrefix="container-xl format-21" key={props.keyUniq}>
      <div className="content">
        {fotoData && (
          <>
            {fotoData?.highlights?.length > 0 && (
                <FotoSlide dataBanner={fotoData.highlights} />
            )}
          </>
        )}

        {/* TITLE */}
        {checkValue(data?.name) && (
          <Row className="title">
            <h1 className="title-text">{data.name}</h1>
          </Row>
        )}

        {/* DESCRIPTION */}
        {checkValue(data?.desc) && (
          <Row className="desc">{parse(data.desc)}</Row>
        )}

        <div className="btn-back-container">
          <button className="btn-back" onClick={() => window.history.back()}>
            <i className="fa fa-chevron-left"></i>
            <span>Kembali</span>
          </button>
        </div>
      </div>
    </Container>
  );
};

export default Format21;
